export const getPriceWithPromocode = (promocode, price) => {
  if (!promocode?.is_active) {
    return price
  }

  if (promocode.discount_percentage) {
    return price - (price * promocode.discount_percentage) / 100
  }

  if (promocode.discount_fixed) {
    return Math.max(price - promocode.discount_fixed, 0)
  }

  return price
}
